<template>
  <div class="sp-template">
    <div class="h-title">账单</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="queryForm" size="small">
          <el-form-item>
            <el-form-item label="账单类型">
              <el-radio-group v-model="queryForm.billType" @change="search" size="small">
                <el-radio-button v-if="in_configs(60107)" label="当期账单"></el-radio-button>
                <el-radio-button v-if="in_configs(60108)" label="历史账单"></el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form-item>
          <!-- <el-form-item label="账单周期">
            <el-date-picker v-model.lazy="queryForm.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
            <el-date-picker v-model.lazy="queryForm.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
          </el-form-item> -->
          <el-form-item label="出账日期">
            <el-date-picker v-model.lazy="queryForm.startCreateAt" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="开始日期"></el-date-picker>
            <el-date-picker v-model.lazy="queryForm.endCreateAt" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item label="账单号">
            <el-input v-model.lazy="queryForm.number" placeholder="账单号" clearable></el-input>
          </el-form-item>
          <el-form-item label="客户">
            <el-select v-model.lazy="queryForm.consumerOrgIds" multiple clearable filterable placeholder="请选择客户">
              <el-option v-for="(d, i) in customerList" :key="i" :label="d.name" :value="d.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="系统">
            <el-select v-model="queryForm.system" filterable placeholder="请选择系统" @change="search">
              <el-option v-for="item in systems" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button v-if="in_configs(60101)" type="primary" v-on:click="search()">搜 索</el-button>
          </el-form-item>
        </el-form>
        <div>
          <el-button v-if="in_configs(60102)" size="small" class="el-button btn-cyan" @click="exportExcel(1)">导出当前页</el-button>
          <el-button v-if="in_configs(60103)" size="small" type="success" @click="exportExcel(2)">导出全部</el-button>
        </div>
      </div>
      <el-table :data="tableData" stripe show-summary :summary-method="getSummaries" v-loading="loading" element-loading-text="数据加载中，请稍候" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="账单号"></el-table-column>
        <el-table-column prop="consumerOrg" label="付款方"></el-table-column>
        <el-table-column prop="providerOrg" label="收款方"></el-table-column>
        <el-table-column prop="currency" label="币种"></el-table-column>
        <el-table-column prop="systemId" label="系统" :formatter="formatSytem"></el-table-column>
        <el-table-column prop="amount" label="账单应还金额"></el-table-column>
        <!-- <el-table-column prop="amount" label="本期消费金额"></el-table-column>
        <el-table-column prop="rechargeAmount" label="充值金额"></el-table-column>
        <el-table-column prop="lastBillEndAmount" label="上期期末金额"></el-table-column> -->
        <!-- <el-table-column prop="repaymentAmount" label="已还金额"></el-table-column> -->
        <!-- <el-table-column prop="billingCycle" label="账单周期"></el-table-column> -->
        <el-table-column prop="createAt" label="出账日期"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <router-link v-if="in_configs(60104) && queryForm.billType=='当期账单'" tag="i" class="iconfont icon-chakan2" title="查看明细" :to="{path: '/transaction', query: {id: scope.row.id,systemId:scope.row.systemId, from: 'bill/query'}}"></router-link>
            <a v-if="in_configs(60105)" class="export-icon" @click.prevent="exportOrderChargeBill(scope.row.id)" title="导出账单">
              <i class="iconfont icon-daochu1"></i>
            </a>
            <router-link tag="i" v-if="in_configs(60106) && (parseInt(scope.row.repaymentAmount) - parseInt(scope.row.debtAmount)) < 0 && scope.row.isConsumer" class="iconfont icon-huankuan1" title="还款" :to="{path: '/recharge',
            query: {billId:scope.row.id, id: scope.row.accountEntity.id, orgOwnerName: scope.row.consumerOrg, orgOwnerId: scope.row.accountEntity.orgOwnerId, 
            providerOrgId: scope.row.accountEntity.providerOrgId, providerOrgName: scope.row.providerOrg, 
            debtAmount: Math.abs(parseInt(scope.row.repaymentAmount) - parseInt(scope.row.debtAmount)), 
            system: scope.row.accountEntity.systemID}}"></router-link>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryForm.currentPage" :page-sizes="page.pageSizes" :page-size="queryForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
      </el-pagination>
    </el-card>
    <form id="theform" target="_blank"></form>
  </div>
</template>

<script>
import { base64ToUint8Array, dateFormat } from '@/util/formUtil'
export default {
  data() {
    return {
      page: {
        total: 0,
        pageSizes: [10, 50, 100, 200]
      },
      customerList: [],
      queryForm: {
        billType: "当期账单",
        consumerOrgIds: [],
        export: 0,
        number: "",
        startDate: "",
        endDate: "",
        startCreateAt: this.getStartTime(),
        endCreateAt: this.getEndTime(),
        pageSize: 10,
        currentPage: 1,
        system: "TMS"
      },
      loading: true,
      tableData: [],
      billTotalAmount: {},
      multipleSelection: [],
      systems: [
        {
          value: "TMS",
          label: "TMS物流系统"
        },
        {
          value: "WMS",
          label: "WMS仓库系统"
        },
        {
          value: "PP",
          label: "小包物流系统"
        }
      ]
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.findByCustomerName();
      this.queryBill();
      this.loading = false;
    }, 500);
  },
  computed: {},
  methods: {
    formatSytem(data) {
      switch (data.systemId) {
        case "TMS":
          return "TMS物流系统";
          break;
        case "WMS":
          return "WMS仓库系统";
          break;
        case "PP":
          return "小包物流系统";
          break;
      }
    },
    findByCustomerName() {
      let _this = this;
      _this.$request1
        .get(
          '/customer/querycustomerAll',
          {
            withCredentials: true
          }
        )
        .then(function(res) {
          if (res.data.success) {
            _this.customerList = res.data.data;
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 表尾合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "amount") {
          sums[index] = this.billTotalAmount.amount; // 这个值应该是后台计算好返回到前台的
        } else if (column.property === "repaymentAmount") {
          sums[index] = this.billTotalAmount.repaymentAmount;
        } else if (column.property === "debtAmount") {
          sums[index] = this.billTotalAmount.debtAmount;
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    search() {
      this.queryForm.currentPage = 1;
      this.queryBill();
    },
    queryBill() {
      if (this.queryForm.billType == "当期账单") {
        this.queryForm.type = "current_period";
      } else {
        this.queryForm.type = "history";
      }
      this.$request1({
        method: 'post',
        data: this.queryForm,
        url: '/bill/query'
      })
        .then(res => {
          if (res.data.success) {
            // console.log(res.data);
            this.page.total = res.data.total;
            if (res.data.total > 0) {
              this.tableData = res.data.data.billResults;
              this.billTotalAmount = res.data.data.billTotalAmount;
            } else {
              this.tableData = [];
              this.billTotalAmount = 0.0;
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    exportExcel(excel) {
      if (this.page.total == 0) {
        this.$message.error("当前无数据");
        return;
      }
      this.queryForm.export = excel;

      this.$request1({
          url: '/bill/query',
          method: 'post',
          data: this.queryForm,
          responseType: 'blob'
        }).then(res => {
          const link = document.createElement('a')
          // let array = base64ToUint8Array(res.data)
          // let blob = new Blob([array])
          let blob = new Blob([res.data])
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          let timestr = dateFormat(new Date(), 'yyyyMMddHHmmss')
          link.setAttribute('download', `bill_${timestr}.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          this.queryForm.export = 0;
        })

      // var form = this.queryForm;
      // var html = "";
      // for (var a in form) {
      //   html +=
      //     '<input type="hidden" name="' + a + '" value="' + form[a] + '" />';
      // }

      // var sfForm = document.getElementById("theform");
      // sfForm.innerHTML = html;
      // sfForm.action = tmsSpringUrl + '/bill/export';
      // sfForm.submit();
      // // this.$windowOpen1(url);
      // this.queryForm.export = 0;
    },
    exportOrderChargeBill(id) {
      this.$windowOpen1(
        '/bill/export' +
          "?billId=" +
          id
      );
    },
    //多选按钮
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.currentPage = 1;
      this.queryBill();
    },
    handleCurrentChange(val) {
      this.queryForm.currentPage = val;
      this.queryBill();
    },
    getStartTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = (Array(2).join(0) + (date.getMonth() + 1)).slice(-2);
      let day = (Array(2).join(0) + date.getDate()).slice(-2);
      month = parseInt(month) - 1;
      if (month == 0) {
        year = parseInt(year) - 1;
        month = 12;
      }
      let days = new Date(year, month, 0);
      if (day > days.getDate()) {
        day = days.getDate();
      }
      return year + "-" + month + "-" + day;
    },
    getEndTime() {
      let date = new Date();
      let year = date.getFullYear();
      let month = (Array(2).join(0) + (date.getMonth() + 1)).slice(-2);
      let day = (Array(2).join(0) + date.getDate()).slice(-2);
      return year + "-" + month + "-" + day;
    }
  }
};
</script>

<style lang="scss" scoped>
.export-icon {
  margin: 0 10px;
}
.iconfont {
  font-size: 12px;
  color: rgb(96, 98, 102);
  &:hover {
    cursor: pointer;
    color: #74beff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/bill/query.vue